import { useFirst, useResult } from '@rails/document/hooks';
import { LinkIcon, EyeIcon } from '@/icons';
import { useSession } from '@/Session';

import Upload from '@/uploads/Upload';
import { Share as ShareModel } from '@/api';

const Share = ({ friendship, upload, children }) => {
  const fetcher = useFirst('shares', {
    where: { uploadId: upload.id, friendshipId: friendship.id },
  });

  const share = useResult(fetcher);

  return (
    <div className='relative'>
      <LinkAction {...{ upload, friendship, share }} />
      <ShowAction {...{ upload, friendship, share }} />
      <Upload {...{ upload }} />
    </div>
  );
};

const LinkAction = ({ upload, friendship, share }) => {
  const unlink = () => share && share.destroy();
  const link = () => {
    const share = new ShareModel({ upload, friendship });
    share.save({ with: ['upload', 'friendship'] });
  };
  const toggleLink = () => (share ? unlink() : link());
  return (
    <button
      className={`btn btn-square absolute left-0 top-0 z-10 p-2 opacity-50 hover:opacity-90 ${share ? 'btn-primary' : ''}`}
      title={share ? 'Ne plus partager cette image' : 'Partager cette image'}
      onClick={toggleLink}
    >
      <LinkIcon />
    </button>
  );
};

const ShowAction = ({ upload, friendship, share }) => {
  const {
    cable: { say },
  } = useSession();
  return (
    share && (
      <button
        className='btn btn-square absolute right-0 top-0 z-10 p-2 opacity-50 hover:opacity-90'
        title='Faire afficher maintenant'
        onClick={() =>
          say('forcedImage', { imageId: share.id, to: friendship.friend.id })
        }
      >
        <EyeIcon />
      </button>
    )
  );
};

export default Share;
